import { MarketCategory } from '@/feature/event-details-sbk/types';

export const getMarketCategoryKey = ({ market_type }: MarketCategory) =>
    `${market_type.code}-${JSON.stringify(market_type.params)}`;
